"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var ReleasePart_1 = require("../../release/model/ReleasePart");

var UserMessageConverter_1 = require("../../user-messages/conversions/UserMessageConverter");

var ReleasePartConverter_1 = require("./ReleasePartConverter");
/**
 * Default implementation of release converter.
 *
 * @author Radek Beran
 */


var ReleasePartConverterImpl =
/*#__PURE__*/
function (_ReleasePartConverter) {
  _inherits(ReleasePartConverterImpl, _ReleasePartConverter);

  function ReleasePartConverterImpl(userMessageConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, ReleasePartConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePartConverterImpl).call(this));
    _this.userMessageConverter = userMessageConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleasePartConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleasePart_1.ReleasePart(ReleasePart_1.ReleasePart.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ReleasePart_1.ReleasePart.schema.productCategoryId.valueOf(conversions.toClassReferenceId(source.productCategoryId)), ReleasePart_1.ReleasePart.schema.workflowCaseId.valueOfField(source), // todo? convert this to class reference id too?
      ReleasePart_1.ReleasePart.schema.calcWorkflowCaseId.valueOfField(source), // todo? convert this to class reference id too?
      ReleasePart_1.ReleasePart.schema.cmDeadlineMissed.valueOfField(source), ReleasePart_1.ReleasePart.schema.approved.valueOfField(source), ReleasePart_1.ReleasePart.schema.firstApproval.valueOfField(source), ReleasePart_1.ReleasePart.schema.approvedByUserId.valueOfField(source), ReleasePart_1.ReleasePart.schema.approvedByUserName.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), ReleasePart_1.ReleasePart.schema.calcProgressMonitorId.valueOf(conversions.toClassReferenceId(source.calcProgressMonitorId)), ReleasePart_1.ReleasePart.schema.readonly.valueOfField(source), ReleasePart_1.ReleasePart.schema.manualPrices.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId)
      });
      Object.assign(result, {
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId)
      });
      Object.assign(result, {
        workflowCaseId: source.workflowCaseId
      });
      Object.assign(result, {
        calcWorkflowCaseId: source.calcWorkflowCaseId
      });
      Object.assign(result, {
        cmDeadlineMissed: source.cmDeadlineMissed
      });
      Object.assign(result, {
        approved: utils_1.Utils.isMoment(source.approved) ? conversions.fromDate(source.approved) : null
      });
      Object.assign(result, {
        firstApproval: utils_1.Utils.isMoment(source.firstApproval) ? conversions.fromDate(source.firstApproval) : null
      });
      Object.assign(result, {
        approvedByUserId: source.approvedByUserId
      });
      Object.assign(result, {
        approvedByUserName: source.approvedByUserName
      });
      Object.assign(result, {
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      Object.assign(result, {
        calcProgressMonitorId: conversions.toDocumentReferenceId(source.calcProgressMonitorId)
      });
      Object.assign(result, {
        readonly: source.readonly
      });
      Object.assign(result, {
        manualPrices: source.manualPrices
      });
      return result;
    }
  }]);

  return ReleasePartConverterImpl;
}(ReleasePartConverter_1.ReleasePartConverter);

ReleasePartConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserMessageConverter_1.UserMessageConverter, ValidationResultConverter_1.ValidationResultConverter])], ReleasePartConverterImpl);
exports.ReleasePartConverterImpl = ReleasePartConverterImpl;